<script>
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../share/utils';

	import Counters from '../../Counters.svelte';
	import Inline_FuckUp from './Inline_FuckUp.svelte';

	export let isRightSide;
	export let pageContentIndex;

	let div;

	onMount(() => {
		jumpByAnchor(div);
	});

	let counters = [
		{
			text: 'Page Views',
			prefix: null,
			suffix: 'Mio.',
			start: 0,
			end: 17,
			animation_time: 1500,
			background: '#22398E',
			color: '#ffffff'
		},
		{
			text: 'zufriedene Studenten',
			prefix: '>',
			suffix: 'Tsd.',
			start: 0,
			end: 10,
			animation_time: 1000,
			background: '#EBC851',
			color: '#ffffff'
		}, {
			text: 'Spenden',
			prefix: null,
			suffix: 'Tsd. €',
			start: 0,
			end: 250,
			animation_time: 3000,
			background: '#C9468A',
			color: '#ffffff'
		}
	]
</script>

<div class="page-regional marginbox">
	<div class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Kulturhauptstadt - Desktop - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/desktop.webp">
			</div>
			<div class="flex element">
				<p class="caption">{getText("14.02.01_caption")}</p>
			</div>
		</div>
		
		<div bind:this={div} id="kulturhauptstadt" class="flex col structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Kulturhauptstadt - Laptop - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/laptop.webp">
			</div>
			
			<div class="flex element">
				<div class="text">
					<h2>{getText("14.02.02_h2")}</h2>
					<p class="caption">{getText("14.02.03_caption")}</p>
				</div>
			</div>
		</div>
		
		<div class="flex col structure-3">
			<div class="flex element">
				<div class="text">
					<h2>{getText("14.02.04_h2")}</h2>
					<p class="caption">{getText("14.02.05_caption")}</p>
				</div>
			</div>
			
			<div class="flex element arm">
				<img loading="lazy" alt="Kulturhauptstadt - mobile - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/arm.webp">
			</div>
		</div>

		<Inline_FuckUp {isRightSide} {pageContentIndex}/>
		
		<div class="flex col structure-4">
			<div class="flex element">
				<img loading="lazy" alt="Kulturhauptstadt - Tablet - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/tablet.webp">
			</div>

			<div class="element offset_text">
				<img loading="lazy" alt="Kulturhauptstadt - Tablet - Design"
					 src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/tablet_placeholder.webp">
				<div class="text">
					<h2>{getText("14.02.06_h2")}</h2>
					<p class="caption">{getText("14.02.07_caption")}</p>


					<!--			need to rewrite counters here, otherwise good positioning is impossible: -->
					<Counters>
						<div class="counters no_margin desktop">
							<h3 class="show_title--true">Facts</h3>
							<div
									style="
								grid-template-rows: repeat(1, 1fr);
								--cols_desktop: 3;
								--cols_tablet: 3;
								--cols_mobile: 1">
								{#each counters as counter}
									<div class="counter" style="
							background-color: {counter.background };
							color: { counter.color }
							">
										<div class="content">
											<p class="animate_numbers"
											   prefix="{ counter.prefix }"
											   suffix="{ counter.suffix }"
											   start="{ counter.start }"
											   end="{ counter.end }"
											   animation_time="{ counter.animation_time }"
											   animation_offset="{ counter.animation_offset }"
											></p>
											{ counter.text }
										</div>
									</div>
								{/each}
							</div>
						</div>
					</Counters>
				</div>
			</div>


			<!--			need to rewrite counters here, otherwise good positioning is impossible: -->
			<Counters>
				<div class="counters no_margin mobile">
					<h3 class="show_title--true">Facts</h3>
					<div
							style="
								grid-template-rows: repeat(1, 1fr);
								--cols_desktop: 3;
								--cols_tablet: 3;
								--cols_mobile: 1">
						{#each counters as counter}
							<div class="counter" style="
							background-color: {counter.background };
							color: { counter.color }
							">
								<div class="content">
									<p class="animate_numbers"
									   prefix="{ counter.prefix }"
									   suffix="{ counter.suffix }"
									   start="{ counter.start }"
									   end="{ counter.end }"
									   animation_time="{ counter.animation_time }"
									   animation_offset="{ counter.animation_offset }"
									></p>
									{ counter.text }
								</div>
							</div>
						{/each}
					</div>
				</div>
			</Counters>




		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		//height: fit-content;
		height: auto;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	.page-regional {
		margin-bottom: 0;

		h2,
		h2 {
			margin-bottom: $media-gap;
		}
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column;
		}
		
		.element {
			min-width: 100px;

			&.arm img {
				transform: translateX(40%);

				@include for-tablet-landscape-up {
					transform: translateX(45%);
				}
			}
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1 {
			width: 100%;
			margin-top: $spacing-mobile;
			margin-bottom: $media-gap;
			padding: 0;
			
			> .element {
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-2 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			
			@include for-tablet-portrait-up {
				flex-flow: nowrap;
			}
			
			> .element {
				margin-bottom: $media-gap;
				height: fit-content;
			}
			
			.element:first-of-type {
				@include for-tablet-portrait-up {
					flex-basis: 70%;
				}
			}
			
			.element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					flex-basis: 30%;
				}
			}
		}
		
		.structure-3 {
			width: 100%;
			padding: 0;
			
			@include for-tablet-portrait-up {
				flex-flow: nowrap;
				width: unset;
			}
			
			> .element {
				margin-bottom: $media-gap;
				height: fit-content;
			}
			
			.element:first-of-type {
				@include for-tablet-portrait-up {
					flex-basis: 55%;
					padding-right: $spacing-mobile*3;
				}
			}
			
			.element:nth-of-type(2) {
				margin-right: -5vw;
				
				@include for-tablet-portrait-up {
					flex-basis: 55%;
				}
			}
		}
		
		.structure-4 {
			width: 100%;
			padding: 0;
			margin-bottom: $spacing-mobile;
			position: relative;

			@include for-tablet-landscape-up {
				margin-bottom: 0;
			}
			
			> .element {
				height: fit-content;
			}
			
			.element {
				margin-bottom: $media-gap;
				order: 1;

				@include for-tablet-landscape-up {
					order: 0;
					width: calc(100% - 10rem);
					margin: 0 5rem;
				}

				&:first-of-type {
					order: 1;
					@include for-tablet-landscape-up {
						order: 0;
					}
				}
				&:nth-of-type(2) {
					order: 0;
					@include for-tablet-landscape-up {
						order: 1;
					}
				}
			}
		}
		
		.text {
			margin: 0;
		}
		
		.logowall {
			margin-top: $spacing-mobile;
		}

		.offset_text {
			img {
				display: none;
			}
			@include for-tablet-landscape-up {
				position: relative;
				margin-top: calc(-100% + 10rem) !important;

				img {
					display: block;
					opacity: 0;
				}

				.text {
					width: 45%;
					margin-left: calc(55% / 2);
				}
			}
		}

		.counters {
			width: 100%;
			margin-left: 0;
			margin-right: 0;
			order: 3;

			&.mobile {
				display: block;

				margin-top: -45vw;

				@include for-tablet-portrait-up {
					margin-top: -36vw;
				}
				@include for-tablet-landscape-up {
					display: none;
				}

				h3 {
					text-align: center;
				}
			}
			&.desktop {
				display: none;
				@include for-tablet-landscape-up {
					display: block;
				}
				// 27.5% from outer .text box
				// 8.87rem is marginbox' margin
				width: auto;
				margin-left: calc((-27.5% * 2) - 8.875rem);
				margin-right: calc((-27.5% * 2) - 8.875rem);

				margin-top: -5vw;

				@media (min-width: 1000px) {
					margin-top: 0;
				}
			}
		}
	}
</style>
